import React from "react";
import { Collapsible as RadixCollapsible } from "radix-ui";
import { cn } from "@/utils/cn";

const Collapsible = RadixCollapsible.Root;
const CollapsibleTrigger = RadixCollapsible.Trigger;

const CollapsibleContent = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof RadixCollapsible.Content>
>(({ className = "", ...props }, ref) => (
  <RadixCollapsible.Content
    ref={ref}
    className={cn(
      "overflow-hidden data-[state=open]:animate-collapsible-down data-[state=closed]:animate-collapsible-up",
      className
    )}
    {...props}
  />
));
CollapsibleContent.displayName = "CollapsibleContent";

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
